//---- components ---------
//---- mixins -------------
import globalMixin from '../common/global-mixin.js';
//---- services -----------
import ProjectHomeService from '../services/projectHome.service.js';
//---- other --------------
//---- 3rd-parties --------

export const initialState = {
  callCenterData: '',
  caseData: '',
  profilesData: [],
  currentProfile: null,
  currentQuest: '',
  allProfiles: '',
  dsData: null,
  currentResultPage: 1,
  showCaseReadOnly: false,
  skinProperties: []
}

export const projectData = {
  //---------------- namespaced --------------------------------------------
  namespaced: true,
  //----------------- state ------------------------------------------------
  state: { ...initialState },
  //----------------- vuex actions  ----------------------------------------
  actions: {

    async openProject({ commit }, reqData) {
      // clear any prior project
      commit('clear')
      // show loading overlay
      commit('showGlobalLoadingOverlay', "open project", { root: true })
      const response = await ProjectHomeService.openProject(reqData)
      if (response?.data?.header) {
        commit('setProfiles', response.data.header.profiles || []);
        commit('header/setHeader', response.data.header, { root: true })
      }
      globalMixin.methods.safeRouterPush('/home')
      return Promise.resolve(response);
    }, // end openProject

    async callGuidedSearch({ commit }, params) {
      const response = await ProjectHomeService.callGuidedSearch(params)
      commit('setCallCenterData', response.data);
      commit('setCurrentResultPage', response.data?.searchResults?.paginationInfo?.currentPage)
      return response.data
    },

    async callUndecidedValue({ commit }, params) {
      const response = await ProjectHomeService.callUndecidedValue(params)
      commit('setCallCenterData', response.data);
      return response.data
    },

    async callUndecidedAttribute({ commit }, params) {
      const response = await ProjectHomeService.callUndecidedAttribute(params)
      commit('setCallCenterData', response.data);
      return response.data
    },

    async skipUndecidedAction({ commit }, params) {
      const response = await ProjectHomeService.skipUndecidedAction(params)
      commit('setCallCenterData', response.data);
      return response.data
    },

    // silentRedirect is used so that if the solution was expired and is no longer visible by the user, we won't display an error, and 
    // we'll just go back to previous state
    async solutionView({ commit }, { caseId, action, silentRedirect }) {
      const response = await ProjectHomeService.solutionView(caseId, action, silentRedirect)
      if (response?.data?.status === 'no-case')
        commit('setCaseData', null);
      else
        commit('setCaseData', response.data);
      return response.data
    },

    invalidateResults({ commit }) {
      commit('invalidateResults');
    },

    setCurrentResultPage({ commit }, currentPage) {
      commit('setCurrentResultPage', currentPage);
    },

    searchFilter({ commit }, params) {
      return ProjectHomeService.searchFilter(params)
        .then(response => {
          if (response && response.data)
            commit('setInitializeData', response.data)
          return Promise.resolve(response);
        })
    },

    browseCasebaseBy({ commit }, params) {
      commit('showGlobalLoadingOverlay', 'run casebase-browser', { root: true });
      return ProjectHomeService.browseCasebaseBy(params)
        .then(response => {
          if (response && response.data)
            commit('setInitializeData', response.data)
          commit('hideGlobalLoadingOverlay', 'browse casebase by ended', { root: true });
          return Promise.resolve(response);
        })
    },

    guidedToogleShowMoreLess({ commit }, params) {
      ProjectHomeService.guidedToogleShowMoreLess(params)
        .then(response => {
          if (response && response.data)
            commit('setGuidedToogleShowMoreLess', response.data)
        })
    },

    setCallCenterData({ commit }, callCenterData) {
      commit('setCallCenterData', callCenterData);
    },

    updateGuidedSearchData({ commit }, guidedSearchData) {
      commit('setGuidedSearchData', guidedSearchData);
    },

    updateFreeTextResult({ commit }, freeTextResult) {
      commit('setFreeTextResult', freeTextResult);
    },

    updateSolutionView({ commit }, caseData) {
      commit('setCaseData', caseData);
    },

    profileData({ commit }, payload) {
      //set current user profile which initially would be the first profle which comes in array object
      commit('setCurrentProfile', payload[0]);
      commit('setCurrentQuest', payload[0].quests[0]);
      commit('loadProfiles', payload);
    },

    setCurrentQuest({ commit }, quest) {
      commit('setCurrentQuest', quest);
    },

    async switchProfile({ commit }, profile) {
      await ProjectHomeService.switchProfile(profile.id)
      commit('setCurrentProfile', profile)
    },

    async searchInitialize({ commit }) {
      let response = await ProjectHomeService.searchInitialize();
      commit('setCallCenterData', response.data);
      return response;
    },

    async runBrowseCasebase({ commit }) {
      let response = await ProjectHomeService.runBrowseCasebase();
      commit('setCallCenterData', response.data);
      return response;
    },

    setSearchResults({ commit }, responseData) {
      commit('setSearchResults', responseData);
    },

    setCases({ commit }, casesData) {
      commit('setCases', casesData);
    },

    setDsInfo({ commit }, dsData) {
      commit('setDsInfo', dsData);
    },

    // call this method to clear project information when going to
    // the project selection page or clicking the home link
    clear({ commit }) {
      commit('clear');
    },

    showCaseReadOnly({ commit }) {
      commit('setShowCaseReadOnly')
    }
  }, // end actions

  //----------------- vuex mutations  -------------------------------------
  mutations: {
    // loads profile data from json and sets it to "profilesData" central store
    setProfiles(state, profiles) {
      state.profilesData = profiles;
      if (!state.currentProfile) {
        if (profiles && profiles[0]) {
          state.currentProfile = profiles[0]
        }
      }
      else{
        state.currentProfile = profiles.find(x =>x.id==state.currentProfile.id);
      }
    },

    // set current profile
    setCurrentProfile(state, cProfile) {
      state.currentProfile = cProfile;
    },

    setCurrentQuest(state, cQuest) {
      state.currentQuest = cQuest;
    },

    //load all available profiles
    loadProfiles(state, payload) {
      state.allProfiles = payload;
    },

    setProjectPageData(state, projectPageData) {
      state.projectPageData = projectPageData;
    },

    setFreeTextResult(state, freeTextResult) {
      state.freeTextResult = freeTextResult;
    },

    setGuidedSearchData(state, guidedSearchData) {
      state.guidedSearchData = '';
      state.guidedSearchData = guidedSearchData;
    },

    setCaseData(state, caseData) {
      state.caseData = caseData;
    },

    invalidateResults(state) {

      // no need to invalidate if there are no results
      if (state?.callCenterData?.searchResults)
        state.callCenterData.searchResults.invalidated = true;

      // console.log("InvalidateResults => " + state ?.callCenterData ?.searchResults ?.invalidated)
    },

    setCurrentResultPage(state, currentPage) {
      // console.log("projectData/setCurrentResultPage")
      state.currentResultPage = currentPage;
    },

    setCallCenterData(state, callCenterData) {
      // console.log("projectData/setCallCenterData")
      state.callCenterData = callCenterData

      // update the current profile if needed
      if (callCenterData.currentProfile && callCenterData.currentProfile != state.currentProfile?.id)
        state.currentProfile = state?.profilesData?.find(p => p.id == callCenterData.currentProfile)

      // update the current quest if needed
      if (callCenterData.currentQuest && state.currentProfile?.quests)
        state.currentQuest = state.currentProfile.quests.find(q => q.id == callCenterData.currentQuest)

      // clear the case data
      state.caseData = '';
    },

    setInitializeData(state, initializeData) {
      state.callCenterData.initialize = initializeData
    },

    setGuidedToogleShowMoreLess(state, responseData) {
      state.callCenterData.values = responseData
    },

    setSearchResults(state, responseData) {
      state.callCenterData.searchResults = responseData
    },

    setCases(state, casesData) {
      state.callCenterData.searchResults.cases = casesData;
    },

    setDsInfo(state, dsData) {
      state.dsData = dsData;
    },

    setShowCaseReadOnly(state) {
      state.showCaseReadOnly = true;
    },

    setSkinProperties(state, skinPropertiesData) {
      state.skinProperties = skinPropertiesData
    },

    clear(state) {
      state.callCenterData = initialState.callCenterData
      state.caseData = initialState.caseData
      state.profilesData = initialState.profilesData
      state.currentProfile = initialState.currentProfiles
      state.currentQuest = initialState.currentQuest
      state.allProfiles = initialState.allProfiles
      state.dsData = initialState.dsData
      // state.skinProperties = initialState.skinProperties
    }
  }, // end mutations

  //----------------- vuex getters  ----------------------------------------
  getters: {
    isProjectOpen(state, getters, rootState) {
      return (state.callCenterData || rootState.dsDashboard.dsDashboardInitData 
                || !!(rootState.header?.headerData?.projects || []).find(x => x.isCurrentProject) );
    },

    caseData(state) {
      //returns current case data
      return state.caseData || {};
    },

    currentProfile(state) {
      //returns current profile info
      return state.currentProfile || {};
    },

    currentQuest(state) {
      //returns current profile info
      return state.currentQuest || {};
    },

    profiles(state) {
      // returns all profile info
      return state.profilesData
    },

    skinProperties(state) {
      return state.skinProperties || []
    },

    states(state) {
      return state.callCenterData?.states || []
    },

    transitions(state) {
      return state.callCenterData?.transitions || []
    },

    customResults(state) {
      const callCenterData = state.callCenterData
      if (!callCenterData)
        return []
      const customResuts = []
      if (callCenterData.custom1Results) {
        callCenterData.custom1Results.captionKey = 'custom-solution-1'
        callCenterData.custom1Results.actionKey = 'custom1'
        customResuts.push(callCenterData.custom1Results)
      }
      if (callCenterData.custom2Results) {
        callCenterData.custom2Results.captionKey = 'custom-solution-2'
        callCenterData.custom2Results.actionKey = 'custom2'
        customResuts.push(callCenterData.custom2Results)
      }
      if (callCenterData.custom3Results) {
        callCenterData.custom3Results.captionKey = 'custom-solution-3'
        callCenterData.custom3Results.actionKey = 'custom3'
        customResuts.push(callCenterData.custom3Results)
      }
      if (callCenterData.custom4Results) {
        callCenterData.custom4Results.captionKey = 'custom-solution-4'
        callCenterData.custom4Results.actionKey = 'custom4'
        customResuts.push(callCenterData.custom4Results)
      }
      if (callCenterData.custom5Results) {
        callCenterData.custom5Results.captionKey = 'custom-solution-5'
        callCenterData.custom5Results.actionKey = 'custom5'
        customResuts.push(callCenterData.custom5Results)
      }
      return customResuts
    },

    resultsInvalidated(state) {
      return state?.callCenterData?.searchResults?.invalidated;
    },

    currentResultPage(state) {
      return state.currentResultPage;
    },

  }, // end getters
};
